var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.text)?_c('v-img',{attrs:{"max-height":_vm.height,"max-width":_vm.width,"src":require("@/assets/logo.svg")}}):(_vm.text)?_c('div',{class:("text-" + _vm.textLevel),domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }